import { WidgetStoreSliceCreator } from '../types';
import type { CountryCode } from '@/utils/location-detection';

export interface LocationStore {
  location: {
    // State
    userCountryCode: CountryCode;
    isDetecting: boolean;
    // Actions
    setUserCountryCode: (countryCode: CountryCode) => void;
    setIsDetecting: (isDetecting: boolean) => void;
  };
}

export const createLocationSlice: WidgetStoreSliceCreator<
  LocationStore
> = set => ({
  location: {
    // State - default to US for USD currency
    userCountryCode: 'US',
    isDetecting: false,
    // Actions
    setUserCountryCode: (countryCode: CountryCode) =>
      set(state => ({ location: { ...state.location, userCountryCode: countryCode } })),
    setIsDetecting: (isDetecting: boolean) =>
      set(state => ({ location: { ...state.location, isDetecting } })),
  },
});
